import ResetError from '@/pages/ResetPassword/error';
import { resetPasswordSearchSchema } from '@/pages/ResetPassword/resetLink';
import { createFileRoute } from '@tanstack/react-router';
import React from 'react';

// `email` is required in that schema, not optional: the form submits it and
// POST /auth/reset-password rejects a request without it, so an emailless link is a dead end —
// failing validateSearch routes it to <ResetError />, which can send a fresh one.
export const Route = createFileRoute('/reset-password/')({
  errorComponent: () => <ResetError />,
  validateSearch: resetPasswordSearchSchema,
});
